<template>
	<v-dialog :fullscreen="isMobile" attach v-model="open" max-width="700px" scrollable>
		<v-card raised>
			<v-card-title class="display-1 modal__title">
				<button type="button" class="btn-flat-icon--dark" @click="open = false">
					<v-icon large>fal fa-times</v-icon>
				</button>
			</v-card-title>
			<v-card-text class="modal__card-text basic-modal-padding">
				<div>
					<div v-for="(line, index) in getGenericModalText" :key="index" class="pb-4">
						{{ line }}
					</div>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
	methods: {
		...mapActions(['setModalOpen'])
	},
	computed: {
		...mapGetters([
			'getModalProp',
			'getGenericModalText',
			'getGenericModalTitle'
		]),
		open: {
			get() {
				return this.getModalProp('genericModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'genericModal', value: val })
			}
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>
